import React from 'react'
import { Box } from 'transfix-ui/core'
import Typography from 'transfix-ui/core/Typography'
import { Maybe } from 'types/graphqlTypes'
import { brandColors } from 'transfix-ui'
import { DISPLAY } from 'constants/display'

interface IVinItem {
  vin: Maybe<string>
}

export const VinItem = ({ vin }: IVinItem) => {
  return (
    <Box
      height='56px'
      display='grid'
      alignItems='center'
      gridTemplateColumns='1fr 160px'
      borderBottom={`1px solid ${brandColors.coolGray2}`}>
      <Typography variant='body2'>{vin || DISPLAY.empty}</Typography>
      <Typography variant='body2'>Y</Typography>
    </Box>
  )
}
